// extracted by mini-css-extract-plugin
export default {"root":"client__src__components__mobile-card-list__root"};